// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio-button_radio__k6KYH","indicator":"radio-button_indicator__vx2Po","scaleIn":"radio-button_scaleIn__u3e7Q"};